export const guestFooterTranslationKeys = {
  agreement: 'auth-form.agreement',
  privacyNotice: 'auth-form.footer-privacy-notice',
}
